import { Button, Divider, Form, Input, Modal, Typography } from 'antd';
import axios from 'axios';
import qs from "qs";
import { useState } from 'react';
import * as analytics from "../../services/Analytics";

export function NicknameChanger({ account, token }) {

    const [isLoading, setIsLoading] = useState(false);

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [form] = Form.useForm();

    function openModal() {

        analytics.clickChangeNickname();

        setIsModalVisible(true);
    }

    function onOk() {
        form
            .validateFields()
            .then(values => {
                onSubmitForm(values);
            })
            .catch(info => {
                console.log(info);
            });
    }

    function onCancel() {

        setIsModalVisible(false);

        form.resetFields();
    }

    async function onSubmitForm(values) {

        try {

            setIsLoading(true);

            const url = 'https://formsubmit.co/ajax/cryptospaceprison@gmail.com';
            const data = qs.stringify({
                form: "change_nickname",
                account: account,
                token: token.edition,
                nickname: values.nickname,
            });
            await axios.post(url, data);

            Modal.success({
                title: "Well done!",
                content: "Soon your nickname will appear in the database of the space prison."
            });

        } catch (error) {
            console.log(error);
            analytics.getError("Failed to submit form for change a nickname: " + JSON.stringify(error));
            Modal.error({
                title: "Ooops!",
                content: "Failed to change a nickname. Try later."
            });
        } finally {
            form.resetFields();
            setIsModalVisible(false);
            setIsLoading(false);
        }

    }

    return (
        <div>
            <Modal
                transitionName=""
                maskTransitionName=""
                visible={isModalVisible}
                title="Change nickname"
                okText="Change"
                cancelText="Cancel"
                onCancel={onCancel}
                onOk={onOk}
                confirmLoading={isLoading}
            >
                <Typography.Paragraph>⚡ A nickname can only be chosen until the start of the next season.</Typography.Paragraph>
                <Typography.Paragraph>🐭 Otherwise, the space prison will choose a nickname for you. Be aware that you may not like it.</Typography.Paragraph>
                <Divider />
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        name="nickname"
                        label={"Input a nickname for prisoner #" + token.edition}
                        rules={[{ required: true, message: 'Please input a nickname!' }]}
                    >
                        <Input placeholder="Richie Rich" disabled={isLoading} />
                    </Form.Item>
                </Form>
            </Modal>

            <Button onClick={() => openModal()}>Change nickname</Button>
        </div>
    )

}